import { Swiper, SwiperSlide } from "vue-awesome-swiper";

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      activeSlide: 1,
      swiper_settings: {
        slidesPerView: 1,
        allowTouchMove: true,
        loop: true,
      },
    }
  },
  computed: {
    getSwiper() {
      return this.$refs[this.swiper_ref].$swiper;
    },
  },
  methods: {
    slide(direction = "next") {
      direction === "next" ? this.getSwiper.slideNext() : this.getSwiper.slidePrev();
    },
    setActiveSlide(index = 1) {
      this.activeSlide = index;
    },
    onSlideChange() {
      this.setActiveSlide(this.getSwiper.realIndex + 1);
    },
  },
};
